import { marketStateSearchSlice } from './marketStateSearch.slice';

export const marketStateSearchReducer = marketStateSearchSlice.reducer;
